// assets
import { IconKey, IconUser } from '@tabler/icons';
import { routeConsts } from 'constants/routeConsts';
import { getRouteConsts } from 'utils/get-route-conts';
// constant
const icons = {
  IconKey,
  IconUser
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const user = {
  id: getRouteConsts(routeConsts.user.index),
  title: 'User',
  caption: 'Pages Caption',
  type: 'group',
  children: [
    {
      id: getRouteConsts(routeConsts.user.index),
      title: 'User',
      type: 'item',
      icon: icons.IconUser,
      url: `${routeConsts.user.index}${routeConsts.user.children.manageUser}`
    }
  ]
};

export default user;
